/* ---------------------------------------------------------------------------
   CTA DU DROP QUI SE DEPLIE EN CHAMP EMAIL

   Deux declencheurs, un seul geste :
   - le bouton de la section d'inscription, qui deroule le formulaire pose juste
     en dessous de lui ;
   - tout lien vers la page du drop (banniere d'accueil, bloc collection), qui
     accueille le formulaire garde au chaud en bas de page.

   Point capital : on ne fabrique JAMAIS le formulaire en JavaScript. La
   protection anti-spam de Shopify n'ajoute son jeton qu'aux formulaires qu'elle
   a rendus elle-meme, et le serveur repond 400 "Missing CAPTCHA token" aux
   autres. L'envoi est donc un envoi de formulaire classique : la page se
   recharge et Shopify renvoie sur ?customer_posted=true.

   Amelioration progressive : sans JavaScript le champ reste affiche sur la
   section d'inscription, et les liens mènent a la landing. Rien ne casse.
   --------------------------------------------------------------------------- */

(function () {
  'use strict';

  var DROP_PAGE = '/pages/fitbit-drop';
  var FLAG = 'drop-signup-sent';
  var WAITLIST_POPUP = 'band-waitlist';
  var SUCCESS = "You're on the list.";

  function isDropLink(link) {
    var href = link.getAttribute('href') || '';
    return href.split('?')[0].replace(/\/$/, '') === DROP_PAGE;
  }

  function focusField(form) {
    var field = form.querySelector('.drop-inline__field');
    if (field) field.focus();
  }

  /* --- Section d'inscription : le formulaire est deja sous le bouton -------- */

  function openSignup(event) {
    var trigger = event.currentTarget;
    var root = trigger.closest('[data-drop-signup]');
    if (!root) return;

    event.preventDefault();
    trigger.hidden = true;
    // Le formulaire sort de display:none : l'animation d'ouverture demarre ici.
    root.classList.remove('drop-signup--collapsed');
    focusField(root);
  }

  /* --- Liens du drop : ils ouvrent le pop-up de liste d'attente ------------ */

  // Le pop-up porte deja tout : le rappel du modele, le choix parmi la collection
  // et le formulaire client de Shopify. Un lien du drop devient donc un simple
  // declencheur : le theme ouvre le pop-up des qu'un element porte aria-controls.
  // Sans JavaScript, le lien reste un lien et mene a la landing, qui contient le
  // meme formulaire. Rien ne casse.
  function armLink(link) {
    if (!document.getElementById(WAITLIST_POPUP)) return;
    link.setAttribute('aria-controls', WAITLIST_POPUP);
  }

  /* --- Confirmation au retour de Shopify ----------------------------------- */

  function note(text) {
    var p = document.createElement('p');
    p.className = 'drop-inline__note drop-inline__note--success';
    p.setAttribute('role', 'status');
    p.textContent = text;
    return p;
  }

  // Shopify renvoie sur ?customer_posted=true pour n'importe quel formulaire
  // client de la page — newsletter du pied de page comprise. Le drapeau pose
  // juste avant l'envoi dit si c'est bien le drop qui a ete soumis.
  function confirmIfPosted() {
    if (location.search.indexOf('customer_posted=true') === -1) return;
    if (sessionStorage.getItem(FLAG) !== '1') return;
    sessionStorage.removeItem(FLAG);

    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (link) {
      if (isDropLink(link) && link.parentNode) link.parentNode.replaceChild(note(SUCCESS), link);
    });
  }

  function flagOnSubmit(form) {
    if (form.dataset.dropFlagged === 'on') return;
    form.dataset.dropFlagged = 'on';
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(FLAG, '1'); } catch (error) { /* navigation privee */ }

      // Shopify va chercher son jeton anti-spam avant de poster : l'avion
      // decolle pendant ce temps mort. Si rien ne part au bout de dix secondes,
      // on rend la main plutot que de laisser le bouton eteint.
      var bar = form.querySelector('.drop-inline');
      if (!bar) return;

      bar.classList.add('is-sending');
      setTimeout(function () { bar.classList.remove('is-sending'); }, 10000);
    });
  }

  /* --- Branchement ---------------------------------------------------------- */

  function arm(element, handler) {
    if (element.dataset.dropInline === 'on') return;
    element.dataset.dropInline = 'on';
    element.addEventListener('click', handler);
  }

  function wire(root) {
    var scope = root || document;

    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (link) {
      if (isDropLink(link)) armLink(link);
    });

    Array.prototype.forEach.call(scope.querySelectorAll('[data-drop-cta]'), function (trigger) {
      arm(trigger, openSignup);
    });

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-drop-signup] form, [data-drop-inline-source] form'),
      flagOnSubmit
    );
  }

  function start() {
    wire(document);
    confirmIfPosted();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Le theme re-rend des sections (editeur, quick buy) : on rebranche.
  document.addEventListener('shopify:section:load', function (event) { wire(event.target); });
})();
